(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["blm-featured-collection"] && !Shopify.designMode) return;
  try {
    
  function updateHeading() {
    var currentDate = new Date();
    // Liquid is not rendered inside {% javascript %}, so the cutoff and the
    // Sunday setting are read from the shared rules the layout emits
    var deliveryRules = window.blmDeliveryRules || {};
    var globalCutoff = typeof deliveryRules.cutoffHour === 'number' ? deliveryRules.cutoffHour : 14;
    var isSunday = currentDate.getDay() === 0 && !deliveryRules.includeSundays;

    var currentHour = currentDate.toLocaleTimeString([], {
      timeZone: 'Africa/Johannesburg',
      hour12: false,
      hour: '2-digit',
    });

    var beforeHeading = document.querySelector('.heading-before-1pm');
    var afterHeading = document.querySelector('.heading-after-1pm');

    if (beforeHeading && afterHeading) {
      if (isSunday || currentHour >= globalCutoff) {
        beforeHeading.style.display = 'none';
        afterHeading.style.display = 'inline';
      } else {
        beforeHeading.style.display = 'inline';
        afterHeading.style.display = 'none';
      }
    }
  }

  var removeProductAdd = document.querySelectorAll('.product-form');
  removeProductAdd.forEach((element) => {
    element.style.display = 'none';
  });

  updateHeading();
  setInterval(updateHeading, 60000);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class FooterMenu extends DetailsDisclosure {
      constructor() {
        super();
        this.alwaysCollapsible = this.hasAttribute('data-always-collapsible');
        this.defaultOpen = this.hasAttribute('data-default-open');
        this.reset(false);
        window.addEventListener('on:breakpoint-change', this.reset.bind(this));
      }

      reset() {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        const isConfirmNewsletter = !isLargeScreen &&
          (window.location.hash === "#footer-signup_form" && this.querySelector('#footer-signup_form') !== null);

        if (this.alwaysCollapsible) {
          this.disclosure.open = this.defaultOpen;
          this.toggle.removeAttribute('tabindex');
        } else {
          this.disclosure.open = isLargeScreen || isConfirmNewsletter;
          if (isLargeScreen) {
            this.toggle.setAttribute('tabindex', '-1');
          } else {
            this.toggle.removeAttribute('tabindex');
          }
        }
      }
    }

    customElements.define('footer-menu', FooterMenu);
  });

  } catch(e) { console.error(e); }
})();
})();
